import { render, staticRenderFns } from "./WikiVideos.vue?vue&type=template&id=3bc82924&scoped=true"
import script from "./WikiVideos.vue?vue&type=script&lang=js"
export * from "./WikiVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc82924",
  null
  
)

export default component.exports